/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { RouterProvider } from 'react-router-dom';
import { Web3AuthProvider } from './providers/Web3AuthProvider';
import { router } from './routes';
import './index.css';
import { Toaster } from './components/ui/toaster';
import { MemberSignerProvider } from './providers/MemberSignerProvider';

// Create a client
const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

ReactDOM.createRoot(document.getElementById('root')!).render(
	<ThemeProvider
		attribute='class'
		defaultTheme='dark'
		enableSystem={true}
		disableTransitionOnChange
		storageKey='prometheus-theme'
	>
		<ConvexProvider client={convex}>
			<MemberSignerProvider>
				<Web3AuthProvider>
					<RouterProvider router={router} />
					<Toaster />
				</Web3AuthProvider>
			</MemberSignerProvider>
		</ConvexProvider>
	</ThemeProvider>
);
